import { CompanyLogo, images, Colors, Icons } from "@analyticsMD/quil";
import { styles as commonStyles } from "./common-styles";
import { css, cx } from "@emotion/css";

import type { FC, ReactNode } from "react";
import { Box } from "@mui/material";

const styles = {
  ...commonStyles,
  background: css`
    background: url("${images.PatientBackground}") ${Colors.qlavender_80};
    background-size: cover;
    color: white;
    height: 5rem;
  `,
  contentWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  logo: css`
    height: 2.25rem;
    width: 6rem;
  `,
  logoLarge: css`
    height: 6rem;
    width: 12rem;
  `,
  placeholderIcon: css`
    height: 15.625rem;
    width: 100%;
    margin-top: 5rem;
    margin-bottom: -1rem;
  `,
  placeholderText: css`
    width: 75%;
    text-align: center;
    color: ${Colors.grey_80};
  `,
  maintentanceText: css`
    padding-top: 1rem;
    margin-left: -1rem;
  `,
};

const longText = `This patient does not qualify for QCard.  For patients that do 
(Inpatient or Observation patients that are 1+ month old), this panel will display 
relevant discharge plan information and intelligence.`;

interface PlaceholderSectionProps {
  placeholderText?: string;
  isMaintenance?: boolean;
  closeButtonCmpt?: ReactNode;
}

const PlaceholderSection: FC<PlaceholderSectionProps> = ({
  placeholderText,
  isMaintenance,
  closeButtonCmpt,
}) => (
  <>
    <Box
      className={cx(styles.headerSection, styles.background)}
      sx={{
        display: "flex",
        justifyContent: closeButtonCmpt ? "flex-end" : "space-between",
      }}
    >
      {!closeButtonCmpt && (
        <CompanyLogo
          className={isMaintenance ? styles.logoLarge : styles.logo}
        />
      )}
      {closeButtonCmpt}
    </Box>
    <Box className={styles.contentWrapper}>
      {!isMaintenance && (
        <Icons.PlaceholderComplete className={styles.placeholderIcon} />
      )}
      {isMaintenance && (
        <Icons.MaintenanceIcon className={styles.placeholderIcon} />
      )}
      <span
        className={
          isMaintenance
            ? cx(styles.placeholderText, styles.maintentanceText)
            : styles.placeholderText
        }
      >
        {placeholderText ? placeholderText : longText}
      </span>
    </Box>
  </>
);

export default PlaceholderSection;
